module.exports = __webpack_public_path__ + "img/1-1P5251T130Y5.020e66d9.png";